export const ENDPOINTS = {
  post_password_reset: "auth/password-reset/",
  post_password_reset_confirm: "auth/password-reset/confirm/",
  post_password_reset_validate_token: "auth/password-reset/validate_token/",
  put_password_update: "/auth/password-update/",
};
